import { Box, TextField, Typography } from '@mui/material';
import React from 'react';

interface ITextFieldProps {
  label: string;
  value?: string;
  onChange?: (newValue: string) => void;
  touched?: boolean;
  errors?: string;
}

const TextFieldComponent = ({
  label,
  value,
  touched,
  errors,
  onChange
}: ITextFieldProps): JSX.Element => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const newValue = event.target.value;
    if (onChange) {
      onChange(newValue);
    }
  };

  return (
    <Box>
      <Typography
        sx={{
          fontSize: '16px',
          fontWeight: 500,
          color: '#44474E',
          marginTop: '15px'
        }}
      >
        {label}
      </Typography>
      <TextField
        sx={{
          width: '100%',
          height: '55px',
          marginTop: '15px'
        }}
        value={value}
        onChange={handleChange}
      />
      <Typography
        sx={{
          color: 'red',
          fontSize: '10px'
        }}
      >
        {touched && errors}
      </Typography>
    </Box>
  );
};

export default TextFieldComponent;
